import { useCombinedQueryStatus } from "../../core/queryHelpers";
import { useEffectiveLimitsQuery, useSharedLimitsQuery } from "../api/limitsApiHooks";
import { Box, Label, Text } from 'tombac';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { LimitSummaryList } from "./LimitSummaryList";
import { sharedLimitSchemas } from "./sharedLimitSchemas";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SharedLimitsSummary = () => {
  const limitsQuery = useSharedLimitsQuery();
  const limits = limitsQuery.data?.limits;
  const user = useUserDetails();
  const odEffectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: 'od'
  });
  const tsEffectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: 'ts'
  });
  const combinedStatus = useCombinedQueryStatus(limitsQuery, odEffectiveLimitsQuery, tsEffectiveLimitsQuery);
  const usages = {
    ...odEffectiveLimitsQuery.data?.result.usage,
    ...tsEffectiveLimitsQuery.data?.result.usage
  };
  return /*#__PURE__*/_jsxs(Box, {
    $backgroundColor: "--neutral-400",
    $display: "grid",
    $gap: "20u",
    $gridTemplateColumns: "96u 1fr max-content",
    $mb: "5sp",
    $p: "2sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "SharedLimitsSummary",
    "data-sentry-source-file": "SharedLimitsSummary.tsx",
    children: [/*#__PURE__*/_jsx(Label, {
      as: "div",
      $mt: "4u",
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SharedLimitsSummary.tsx",
      "data-sentry-element": "Label",
      children: "Shared limits"
    }), combinedStatus.isError && /*#__PURE__*/_jsx(Text, {
      $mt: "0.2em",
      as: "span",
      variant: "danger",
      children: "Error: Could not load data."
    }), combinedStatus.isLoading && /*#__PURE__*/_jsx(Text, {
      $mt: "0.2em",
      as: "span",
      variant: "secondary",
      children: "Loading..."
    }), combinedStatus.isSuccess && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(LimitSummaryList, {
        limits: limits ?? {},
        schemas: sharedLimitSchemas,
        usages: usages,
        numberOfColumns: 2
      })
    })]
  });
};